/**
 * Renders a registered screen by id, for pages that show other screens inside them (a hub's tabs, the Control Centre's
 * Apps tab). The router sets the renderer once (routes.tsx), so these pages need not import the router.
 */
import type { ReactNode } from 'react';

let renderer: (screenId: string) => ReactNode = () => null;
export function setScreenRenderer(fn: (screenId: string) => ReactNode) { renderer = fn; }
export function renderScreen(screenId: string): ReactNode { return renderer(screenId); }
